import React, { useEffect,useState } from "react";
import { Col, Form, Input, Row } from "reactstrap";
import { useFormik } from "formik";
import {  DepartmentOptions, enrollmentOptions, formikAddPatient, genderOptions, languageOptions, legalImmigrationOptions, maritalOptions, yesNoOptions } from "./Constant";
import { failed, success } from "../../utils/Tostify";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router";
import * as Yup from "yup";
const SSNPattern = /^(?!000|666|9\d{2})\d{3}-(?!00)\d{2}-(?!0000)\d{4}$/;
import noProfileImg from "../../../src/assets/images/noImage.jpg";
import DatePickerSelector from "../../components/InputFields/DatePicker";
import TextInput from "../../components/InputFields/TextInput";
import { useGetStates } from "../../hooks/useGetStates";
import { createPatient, updatePatientById } from "../../api/patient";
import Loader from "../../components/Loader/Loader";
import { decryptData } from "../../utils/helper";
import { decryptPatientData } from "../../utils/common";
import { handleFileUpload } from "../../utils/ImageToBase64";
import { setSortBy } from "../../context/reducers/pagination";
import MultiSelect from "../../components/InputFields/MultiSelect";

const EditPatientProfile = ({ setIsPatientCreated, setPatientDetails }) => {
  const [isLoading, setIsLoading] = useState(false);
  const { states } = useGetStates("US");
  const dispatch = useDispatch();
  let token = useSelector(state => state.userReducer.token);
  const [selectedImage, setSelectedImage] = useState();
  const navigate = useNavigate();
  const [image, setImageFile] = useState();
  const [isSSNEnabled, setIsSSNEnabled] = useState(false);
  const [isTaxPayerEnabled, setIsTaxPayerEnabled] = useState(false);
  const location = useLocation();
  const patientDeatils = location.state?.patientDeatils;
  console.log("patientDeatils----", patientDeatils);

  const handleImageChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      setSelectedImage(URL.createObjectURL(e.target.files[0]));
      setImageFile(e.target.files[0]);
    }
  };
  const formik = useFormik({
    ...formikAddPatient,
    validationSchema: Yup.object().shape({
      ...formikAddPatient.validationSchema.fields,
      socialSecurityNumber: !isSSNEnabled
        ? Yup.string().matches(SSNPattern, "Enter a valid SSN code").required("SSN is required")
        : Yup.string().matches(SSNPattern, "Enter a valid SSN code"),
      taxPayerNumber: !isTaxPayerEnabled
        ? Yup.string().required("Taxpayer ID is required")
        : Yup.string()
    }),
    onSubmit: async (values) => {
      let res;
      let base64pdfForm = "";
      try {
        setIsLoading(true);
        if (!patientDeatils._id) {
          if (selectedImage && image) {
            base64pdfForm = await handleFileUpload(image);
          }
          const payload = {
            ...values,
            departmentAprvlStatus: values.departmentAprvlStatus || "New Patient",
            medicaidEnrollmentStatus: values.medicaidEnrollmentStatus || "Not Started",
            orgId: localStorage.getItem("currentOrgId"),
            clinicId: localStorage.getItem("currentHospitalId"),
            houseHoldSize: 1,
            profileImage: {
              name: image?.name || "",
              base64Image: base64pdfForm || ""
            }
          };
          res = await createPatient({ values: payload, dispatch, token });
          const responseData = decryptData(res.data);
          const decryptedPatient = await decryptPatientData(responseData);
          if (res?.status == "SUCCESS") {
            setPatientDetails(decryptedPatient);
            setIsLoading(false);
            setIsPatientCreated(true);
            success(res?.message);
            navigate("/clinic/patient-profile", { state: { patientData: decryptedPatient?._id } });
            dispatch(setSortBy({ column: "", desc: false }));
          } else {
            setIsLoading(false);
            failed(res?.message);
          }
        } else {
          const payload = { ...values };
          if (image) {
            base64pdfForm = await handleFileUpload(image);
            payload.profileImage = {
              name: image?.name || "",
              base64Image: base64pdfForm || ""
            };
          }
          res = await updatePatientById({ payload, dispatch, token, patientId: patientDeatils._id });
          if (res?.status == "SUCCESS") {
            setIsLoading(false);
            navigate("/app/patient/profile", { state: { patientData: patientDeatils?._id } });
            setSelectedImage();
            setImageFile();
            success(res?.message);
          } else {
            setIsLoading(false);
            failed(res?.message);
          }
        }
      } catch (error) {
        setIsLoading(false);
        failed(res?.message);
      }
    }
  });
  useEffect(() => {
    if (patientDeatils?._id) {
      formik.setValues({
        name: patientDeatils.name.text,
        email: patientDeatils.telecom?.find(t => t.system === 'email')?.value || "",
        gender: patientDeatils.gender || "",
        dob: patientDeatils.birthDate || "",
        mrnNumber: patientDeatils.mrnNumber || "",
        coverage: patientDeatils.coverage || false,
        homePhone: String(patientDeatils.telecom?.find(t => t.system === 'homePhone' && t.use === 'home')?.value || ""),
        address: patientDeatils.address?.line || "",
        state: patientDeatils.address?.state || "",
        postalCode: patientDeatils.address?.postalCode || "",
        city: patientDeatils.address?.city || "",
        maritalStatus: patientDeatils.maritalStatus || "",
        taxPayerNumber: patientDeatils.taxPayerNumber || "" || "",
        doa: String(patientDeatils.doa || ""),
        socialSecurityNumber: String(patientDeatils?.socialSecurityNumber || ""),
        phone: String(patientDeatils.telecom?.find(t => t.system === 'phone')?.value || ""),
        isDisable: patientDeatils.isDisable || false,
        isPregnant: patientDeatils.isPregnant || false,
        isLegalImmigrant: patientDeatils.isLegalImmigrant || null,
        departmentAprvlStatus: patientDeatils.departmentAprvlStatus || null,
        isUsCitizen: patientDeatils.isUsCitizen || false,
        medicaidElegibitlyGroup: patientDeatils.medicaidElegibitlyGroup || [],
        isVeterian: patientDeatils.isVeterian || false,
        medicaidEnrollmentStatus: patientDeatils.medicaidEnrollmentStatus || null,
        language: patientDeatils?.language

      });
      setIsSSNEnabled(!patientDeatils?.socialSecurityNumber);
      setIsTaxPayerEnabled(!patientDeatils?.taxPayerNumber);
    }
  }, [patientDeatils]);
  return (
    <div className="profile_container">
      {isLoading ? <Loader /> : null}
      <Form onSubmit={formik.handleSubmit}>
        <h5 className="title_name mt-3">Personal Information</h5>
        <div className="row application_details_block mt-3">
          <Row className="mx-0 p-0">
            <Col xs={12} sm={6} lg={4} className="mb-2">
              <TextInput
                keyField={"name"}
                label="Full Name"
                formik={formik}
                type="text"
                // placeholder="First Name"
                value={formik.values.name}
                onChange={(e) =>
                  formik.setFieldValue("name", e.target.value)
                }
                />
            </Col>
            <Col xs={12} sm={6} lg={4} className="modal_pro_file mb-2">
              <DatePickerSelector
                keyField={"dob"}
                formik={formik}
                value={formik.values?.dob}
                minDate={""}
                maxDate={moment()}
                label={
                  <>
                    Date Of Birth <span style={{ color: 'red' }}>*</span>
                  </>
                }
                type="date"
                onChange={(e) =>
                  formik.setFieldValue("dob", moment(e).format("MM-DD-YYYY"))
                }
              />
            </Col>
            <Col xs={12} sm={6} lg={4} className="mb-2">
              <TextInput
                keyField={"mrnNumber"}
                formik={formik}
                label="MRN Number"
                type="text"
                required={false}
                // placeholder="15216515443"
                value={formik.values.mrnNumber}
                onChange={(e) =>
                  formik.setFieldValue("mrnNumber", e.target.value)
                }
              />
            </Col>
            <Col xs={12} sm={6} lg={4}>
              <TextInput
                keyField={"coverage"}
                formik={formik}
                required={false}
                label="Coverage"
                type="select"
                placeholder="Select"
                options={yesNoOptions}
                value={formik.values.coverage}
                onChange={(e) => formik.setFieldValue("coverage", e.target.value)}
              />
            </Col>
            <Col xs={12} sm={6} lg={4} className="mb-2">
              <TextInput
                keyField={"socialSecurityNumber"}
                formik={formik}
                label="Social Security Number (SSN)"
                type="ssn"
                required={!isSSNEnabled}
                value={formik.values.socialSecurityNumber}
                readOnly={isSSNEnabled}
                onChange={(e) => formik.setFieldValue("socialSecurityNumber", e.target.value)}
              />
              <span>I do not qualify for SSN</span>
              <Input type="checkbox"
                disabled={formik.values.socialSecurityNumber}
                checked={isSSNEnabled}
                onChange={() => { setIsSSNEnabled(!isSSNEnabled); formik.setFieldValue("socialSecurityNumber", ""); }} />
            </Col>
            <Col xs={12} sm={6} lg={4} className="mb-2">
              <TextInput
                keyField={"taxPayerNumber"}
                formik={formik}
                required={!isTaxPayerEnabled}
                readOnly={isTaxPayerEnabled}
                label="Taxpayer ID (ATIN/ITIN)"
                type="text"
                // placeholder="***-***-1234"
                value={formik.values.taxPayerNumber}
                onChange={(e) => formik.setFieldValue("taxPayerNumber", e.target.value)}
              />
              <span>I do not qualify for Taxpayer</span>
              <Input type="checkbox"
                disabled={formik.values.taxPayerNumber}
                checked={isTaxPayerEnabled}
                onChange={() => { setIsTaxPayerEnabled(!isTaxPayerEnabled); formik.setFieldValue("taxPayerNumber", ""); }} />
            </Col>
          </Row>
        </div>
        <h5 className="title_name mt-3">Misc Information</h5>
        <div className="row application_details_block mt-3">
          <Row className="mx-0 p-0">
            <Col xs={12} sm={6} lg={4} className="mb-2">
              <TextInput
                keyField={"gender"}
                formik={formik}
                label="Gender"
                options={genderOptions}
                type="select"
                placeholder="Select"
                value={formik.values.gender}
                onChange={(e) => {
                  const selectedGender = e.target.value;
                  formik.setFieldValue("gender", selectedGender);
                  formik.setFieldValue("isPregnant", false);
                }}
              />
            </Col>
            <Col xs={12} sm={6} lg={4} className="mb-2">
              <TextInput
                keyField={"maritalStatus"}
                label="Marital Status"
                formik={formik}
                type="select"
                placeholder="Select"
                options={maritalOptions}
                value={formik.values.maritalStatus}
                onChange={(e) => formik.setFieldValue("maritalStatus", e.target.value)}
              />
            </Col>
            <Col xs={12} sm={6} lg={4} className="mb-2">
              <TextInput
                keyField={"isPregnant"}
                formik={formik}
                required={false}
                label="Pregnant"
                readOnly={formik.values.gender === "Male"}
                type="select"
                placeholder="Select"
                options={yesNoOptions}
                value={formik.values.isPregnant}
                onChange={(e) => formik.setFieldValue("isPregnant", e.target.value)}
              />
            </Col>
            <Col xs={12} sm={6} lg={4} className="mb-2">
              <TextInput
                keyField={"isUsCitizen"}
                formik={formik}
                required={false}
                label="US Citizen"
                type="select"
                placeholder="Select"
                options={yesNoOptions}
                value={formik.values.isUsCitizen}
                onChange={(e) => formik.setFieldValue("isUsCitizen", e.target.value)}
              />
            </Col>
            <Col xs={12} sm={6} lg={4} className="mb-2">
              <TextInput
                keyField={"isDisable"}
                formik={formik}
                required={false}
                label="Disability"
                type="select"
                placeholder="Select"
                options={yesNoOptions}
                value={formik.values.isDisable}
                onChange={(e) => formik.setFieldValue("isDisable", e.target.value)}
              />
            </Col>
            <Col xs={12} sm={6} lg={4} className="mb-2">
              <TextInput
                keyField={"isVeterian"}
                formik={formik}
                required={false}
                label="Veteran"
                type="select"
                placeholder="Select"
                options={yesNoOptions}
                value={formik.values.isVeterian}
                onChange={(e) => formik.setFieldValue("isVeterian", e.target.value)}
              />
            </Col>
            <Col lg={6} className="location_block doc_type_blkk ">
              <MultiSelect
                  keyField={"language"}
                  formik={formik}
                  required={false}
                  type="select"
                  label="Language Preference"
                  placeholder="Select"
                  options={languageOptions}
                  value={formik.values.language}
                  onChange={(e) =>
                      formik.setFieldValue("language", e)
                  }
                  />
              </Col>
          </Row>
        </div>
        <h5 className="title_name mt-3">Contact Information</h5>
        <div className="row application_details_block mt-3">
          <Row className="mx-0 p-0">
            <Col xs={12} sm={6} lg={4} className="mb-2">
              <TextInput
                keyField={"address"}
                formik={formik}
                label="Address"
                type="text"
                value={formik.values.address}
                onChange={(e) =>
                  formik.setFieldValue("address", e.target.value)
                }
              />
            </Col>
            <Col xs={12} sm={6} lg={4} className="mb-2">
              <TextInput
                keyField={"state"}
                label="State"
                formik={formik}
                type="select"
                options={states.map((obj) => {
                  return {
                    label: obj.name,
                    value: obj.name
                  };
                })}
                placeholder="State"
                value={formik.values.state}
                onChange={(e) => formik.setFieldValue('state', e.target.value)}
              />
            </Col>
            <Col xs={12} sm={6} lg={4} className="mb-2">
              <TextInput
                keyField={"postalCode"}
                formik={formik}
                label="Zip Code"
                type="text"
                // placeholder="Zip Code"
                value={formik.values.postalCode}
                onChange={(e) =>
                  formik.setFieldValue("postalCode", e.target.value)
                }
              />
            </Col>
            <Col xs={12} sm={6} lg={4} className="mb-2">
              <TextInput
                keyField={"city"}
                formik={formik}
                label="City"
                type="text"
                // placeholder="City"
                value={formik.values.city}
                onChange={(e) => formik.setFieldValue("city", e.target.value)}
              />
            </Col>
            <Col xs={12} sm={6} lg={4} className="mb-2">
              <TextInput
                keyField={"email"}
                label="Email"
                formik={formik}
                required={false}
                type="email"
                // readOnly={patientDeatils._id ? true : false}
                readOnly={patientDeatils._id && patientDeatils.isAccountCreated ? true : false}
                // placeholder="Email"
                value={formik.values.email}
                onChange={(e) => formik.setFieldValue("email", e.target.value)}
              />
            </Col>
            <Col xs={12} sm={6} lg={4} className="mb-2">
              <TextInput
                keyField={"homePhone"}
                formik={formik}
                label="Primary Phone"
                type="phone"
                placeholder="+1-324-234-32423"
                value={formik.values.homePhone}
                onChange={(e) => formik.setFieldValue("homePhone", e)}
              />
            </Col>
            <Col xs={12} sm={6} lg={4} className="mb-2">
              <TextInput
                keyField={"phone"}
                formik={formik}
                required={false}
                label="Secondary Phone"
                type="phone"
                // placeholder="+1-324-234-32423"
                value={formik.values.phone}
                onChange={(e) => formik.setFieldValue("phone", e)}
              />
            </Col>
          </Row>
        </div>
        <div className="d-flex justify-content-center gap-3 mt-3">
          <button className="save_btn" type="button" onClick={() => { patientDeatils?._id ? navigate("/app/patient/profile", { state: { patientData: patientDeatils?._id } }) : navigate("/clinic/patient-list"); }}>Cancel</button>
          <button className="save_btn saving" type="submit">
            Save
          </button>
        </div>
      </Form>
    </div >
  );
};

export default EditPatientProfile;
